
/* tslint:disable:object-literal-sort-keys */

export const messages = {
    en: {
        auth: {
            login: {
                error: {
                    credentials: 'Username and/or password incorrect',
                    network: 'Communication with server has failed'
                },
                form: {
                    password: { error: 'Please enter your username', label: 'Password' },
                    submit: 'Log in',
                    submitting: 'Logging in',
                    username: { error: 'Please enter your password', label: 'Username' }
                }
            },
            renew: {
                slowNetwork: 'This is taking more time than usual. Please do not quit the application.',
                spinner: 'Getting you back online'
            }
        },
        actionBar: {
            newItems: 'New Items',
            auditCampaign: 'Audit Campaigns',
            synchro: 'Synchro'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Deployment',
                checkForUpdate: {
                    help: 'If an update is available, it will be installed automatically.',
                    title: 'Please check for updates'
                },
                clearCache: {
                    help: 'If you are offline, this process will remove access to all data stored on your device',
                    title: 'Clear cache memory'
                },
                overrideLocale: {
                    help: 'The english langage will be used and your device’s settings will be ignored',
                    title: 'Force english langage'
                },
                resetLocaleOverride: {
                    help: 'The langage will depend on your device’s settings',
                    title: 'Reset the language'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Are you sure that you want to log out?'
        },
        offlineRibbon: { offline: 'You are now offline', online: 'You are now online' },
        proxy: {
            error: {
                default: 'An error occured on the resource {uri}',
                network: 'Communication with the server has failed',
                notFound: 'The resource {uri} could not be found',
                tokenHasExpired: 'Your session has expired'
            }
        },
        serviceWorker: {
            updateAvailable: 'An update has been installed. You can either click here to refresh the page or restart the application.'
        },
        itemCard: {
            detailsNotAvailable: 'Details not available',
            error: 'The item cannot be displayed',
            identifier: 'N° Inv. {identifier}',
            identifierError: 'Identifier error',
            location: 'Location',
            locationLabel: 'Destination: <strong>{title}</strong>',
            unknownLocation: 'Unkonwn',
            title: 'Title',
            locationSelector: { title: 'Select a location', validate: 'Validate' }
        },
        entity: {
            addItem: {
                error: {
                    api: 'The object could not be added',
                    network: 'The communication with the server has failed'
                },
                form: {
                    id: {
                        alreadyAdded: 'The object already exists in this selection',
                        emptyError: 'Please scan an item barcode or type its inventory number',
                        label: 'Inventory number',
                        notFoundError: 'The item is unknown'
                    },
                    location: {
                        emptyError: 'Select a location',
                        label: 'Arrival location',
                        notFoundError: 'Unknown location'
                    },
                    submit: 'Add',
                    submitting: 'Adding...'
                },
                modal: { title: 'Add an item' }
            },
            closeMovement: {
                form: {
                    location: {
                        inputPlaceholder: 'Select a location...',
                        noResult: 'There is no result'
                    }
                }
            }
        },
        firewall: {
            collabWarningMessage: "Your account doesn't any associated collaborator, the app may be disfunctionning",
            noGroupForUserWarningMessage: 'You user account needs to be part of group of users to be able to user SKINreporter'
        },
        maskFields: {
            boolean: { no: 'No', undefined: 'Undefined', yes: 'Yes' },
            entitySelect: { modalPlaceholder: 'Keywords or identifiers...' }
        },
        editItemScreen: {
            author: 'Author',
            inventoryNumber: 'Inventory Number',
            saveNotification: {
                errorMessage: 'En error occured while saving the item',
                successMessage: 'Item successfully saved'
            },
            deleteNotification: {
                errorMessage: 'TRANSLATING IN PROGRESS',
                successMessage: 'TRANSLATING IN PROGRESS'
            },
            deleteModificationsNotification: {
                errorMessage: 'TRANSLATING IN PROGRESS',
                successMessage: 'TRANSLATING IN PROGRESS'
            },
            menu: {
                saveModifications: 'Save modifications',
                deleteNotSynchronizedNewItem: 'TRANSLATING IN PROGRESS',
                deleteModificationsNotSynchronized: 'TRANSLATING IN PROGRESS',
                offlineWarning: 'Modifications are saved on this device, you will have to synchronize them with the database when the network is back.',
                offlineShortWarning: 'Modified on this device',
                addToCampaign: 'MISSING TRANSLATION'
            }
        },
        editRecordScreen: {
            auditDate: 'Audit date',
            linkedObject: 'Linked item',
            realTimeLocation: 'Realtime location',
            itemNotice: 'Go to item',
            recordStatus: 'Record status',
            medias: { accordionPanelTitle: 'ATTACHED MULTIMEDIA' },
            menu: {
                saveModifications: 'Save modifications',
                changeRecordStatus: 'Change record status',
                statusModificationWarning: 'Confirm modification ?',
                offlineWarning: 'Modifications are saved on this device, you will have to synchronize them with the database when the network is back.',
                offlineShortWarning: 'Modified on this device'
            },
            notifications: {
                saveError: 'An error occurred while saving',
                saveSuccess: 'Record saved',
                stateTransitionError: 'An error occurred while modifying the record',
                stateTransitionSuccess: 'record status successfully updated'
            }
        },
        defectTree: {
            annotation: {
                deleteConfirmationMessage: 'Confirm deletion ?',
                defaultImageConfirmationMessage : 'Set as default image ?'
            }
        },
        itemSearchScreen: {
            camera: 'CAMERA',
            modifyRecord: 'MODIFY ITEM RECORD',
            createNewItem: 'CREATE NEW ITEM'
        },
        searchFeaturedCard: {
            institutionLabel: 'Institution'
        },
        auditCampaignSearchScreen: {
            inProgress: 'In progress',
            title: 'Audit Campaigns in progress',
            noResultsPlaceholder: 'You are not authorized to work on any campaign at this time'
        },
        recordSearchScreen: {
            auditors: 'Auditors',
            campaignManager: 'Campaign manager',
            inventoryNumber: 'Inventory number',
            projectCreationDate: 'Project creation date',
            projectType: 'Project type',
            realTimeLocation: 'Realtime location',
            recordRefNumber: 'Record reference number',
            status: 'Status',
            title: 'Audit records',
            unknowLocation: 'Unknown location',
            menu: { addItem: 'Add item' }
        },
        state: {
            all: 'All',
            archived: 'Archived',
            canceled: 'Canceled',
            finalized: 'Finalized',
            inPreparation: 'In preparation',
            inProgress: 'In progress',
            programmed: 'Programmed',
            toValidated: 'Needs validation',
            validated: 'Validated',
            aborted: 'Aborted',
            success: 'Successfully finished',
            error: 'Error',
            none: 'No previous synchronization'
        },
        time: { hours: 'hour(s)', minutes: 'minute(s)', seconds: 'second(s)' },
        locationSelector: {
            inputPlaceholder: 'Type a location',
            title: 'Select a location',
            validate: 'Validate'
        },
        synchroModal: {
            lastFetch: 'Last fetching',
            duration: 'Duration',
            status: 'Status',
            details: 'Details',
            lastSynchro: 'Last synchronization',
            noEntityToSync: 'No entity to synchronize',
            connectionWarningPrefix: 'You must have an internet connection to be able to',
            connectWarningSend: 'send',
            connectWarningRetrieve: 'retrive',
            connectionWarningSuffix: 'data',
            noDataToSync: 'No data to synchronize for now',
            localIconInfoPrefix: 'The icon',
            localIconInfoSuffix: ' indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.',
            retrieveAll: 'Retrieve All',
            finishedSynchros: 'Finished synchronizations',
            syncAll: 'Sychronize all',
            remainsToSynchronize: 'Remains to synchronize'
        },
        entityNames: {
            items: 'Items',
            auditRecords: 'Audit records',
            audits: 'Audit campaings',
            thesaurusTerms: 'Thesaurus terms',
            thesaurus: 'Thesaurus',
            entityFields: 'System data',
            collaborators: 'Collaborators',
            authorities: 'Authorities',
            aliases: 'Aliases',
            locations: 'Locations'
        },
        search: {
            options: {
                sortType: {
                    auditType: 'MISSING TRANSLATION',
                    campaignCreationDate: 'MISSING TRANSLATION',
                    identificationNumber: 'MISSING TRANSLATION',
                    creationDate: 'Date of Creation',
                    identifier: 'Main identifier',
                    lastModification: 'Last Modification',
                    mainTitle: 'Main Title',
                    referenceNumber: 'Reference number'
                }
            },
            queryPlaceholder: 'MISSING TRANSLATION',
            totalCount: 'MISSING TRANSLATION'
        },
        itemCreationImagePopup : {
            title: 'MISSING TRANSLATION',
            addImage: 'MISSING TRANSLATION',
            ignore: 'MISSING TRANSLATION'
        }
    },
    fr: {
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        actionBar: {
            newItems: 'Nouveaux objets',
            auditCampaign: 'Campagnes de récolement',
            synchro: 'Synchro'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: {
            offline: 'Vous êtes hors connexion',
            online: 'Vous êtes connecté'
        },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la ressource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: { title: 'Choisissez une localisation', validate: 'Valider' }
        },
        entity: {
            addItem: {
                error: {
                    api: "L'objet n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: "Numéro d'inventaire",
                        notFoundError: "L'objet est inconnu"
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue'
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...'
                },
                modal: { title: 'Ajouter un objet' }
            },
            closeMovement: {
                form: {
                    location: {
                        inputPlaceholder: 'Entrez une localisation...',
                        noResult: 'Aucun résultat'
                    }
                }
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        maskFields: {
            boolean: { no: 'Non', undefined: 'Non défini', yes: 'Oui' },
            entitySelect: { modalPlaceholder: 'Mots clés ou identifiants...' }
        },
        editItemScreen: {
            author: 'Auteur',
            inventoryNumber: "N° d'inventaire",
            saveNotification: {
                errorMessage: "Une erreur est survenue pendant la sauvegarde de l'objet",
                successMessage: "L'objet a été sauvegardé avec succès"
            },
            deleteNotification: {
                errorMessage: "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
                successMessage: "L'objet a été supprimé avec succès"
            },
            deleteModificationsNotification: {
                errorMessage: "Une erreur est survenue pendant la suppression des modifications non synchronisées",
                successMessage: "Les modifications ont été annulées"
            },
            menu: {
                saveModifications: 'Sauvegarder les modifications',
                deleteNotSynchronizedNewItem: 'Supprimer le nouvel objet',
                deleteModificationsNotSynchronized: 'Supprimer les modifications non synchronisées',
                offlineWarning: "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                offlineShortWarning: 'Modifié sur cet appareil',
                addToCampaign: "Récoler cet objet"
            }
        },
        editRecordScreen: {
            auditDate: 'Date de récolement',
            linkedObject: 'Objet lié',
            realTimeLocation: 'Localisation en temps réel',
            itemNotice: 'Fiche objet',
            recordStatus: 'Statut de la fiche',
            medias: { accordionPanelTitle: 'MÉDIAS' },
            menu: {
                saveModifications: 'Sauvegarder les modifications',
                changeRecordStatus: 'Modifier le statut de la fiche',
                statusModificationWarning: 'Confirmer la modification ?',
                offlineWarning: "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                offlineShortWarning: 'Modifié sur cet appareil'
            },
            notifications: {
                saveError: 'Une erreur est survenue lors de la sauvegarde',
                saveSuccess: 'Fiche de récolement sauvegardée',
                stateTransitionError: 'Une erreur est survenue pendant la modification du statu de la fiche',
                stateTransitionSuccess: 'Statut de la fiche modifié avec succès'
            }
        },
        defectTree: {
            annotation: {
                deleteConfirmationMessage: 'Confirmer la suppression ?',
                defaultImageConfirmationMessage : 'Définir comme image par défaut ?'
            }
        },
        itemSearchScreen: {
            camera: 'APPAREIL PHOTO',
            modifyRecord: 'MODIFIER LA FICHE OBJET',
            createNewItem: 'CRÉER UN NOUVEL OBJET'
        },
        searchFeaturedCard: {
            institutionLabel: 'Institution'
        },
        auditCampaignSearchScreen: {
            inProgress: 'En cours',
            title: 'Projets de pointage/récolement en cours',
            noResultsPlaceholder: "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        recordSearchScreen: {
            auditors: 'Récoleurs',
            campaignManager: 'Responsable de la campagne',
            inventoryNumber: "N° d'inventaire",
            projectCreationDate: 'Date de création du projet',
            projectType: 'Type de projet',
            realTimeLocation: 'Localisation en temps réel',
            recordRefNumber: 'Référence fiche',
            status: 'Statut',
            title: 'Fiches de récolement',
            unknowLocation: 'Localisation Inconnue',
            menu: { addItem: 'Ajouter un objet' }
        },
        state: {
            all: 'Tous',
            archived: 'Archivé',
            canceled: 'Annulé',
            finalized: 'Terminé',
            inPreparation: 'En préparation',
            inProgress: 'En cours',
            programmed: 'Planifié',
            toValidated: 'À valider',
            validated: 'Validé',
            aborted: 'Interrompue',
            success: 'Terminée avec succès',
            error: 'Erreur',
            none: 'Aucune synchronisation précédente'
        },
        time: { hours: 'heure(s)', minutes: 'minute(s)', seconds: 'seconde(s)' },
        locationSelector: {
            inputPlaceholder: 'Entrez une localisation',
            title: 'Choisissez une localisation',
            validate: 'Valider'
        },
        synchroModal: {
            lastFetch: 'Dernière récupération',
            duration: 'Durée',
            status: 'Statut',
            details: 'Détails',
            lastSynchro: 'Dernière synchronisation',
            noEntityToSync: 'Aucune entité à synchroniser',
            connectionWarningPrefix: 'Vous devez être connecté à internet pour pouvoir',
            connectWarningSend: 'envoyer',
            connectWarningRetrieve: 'récupérer',
            connectionWarningSuffix: 'des données',
            noDataToSync: 'Aucune donnée à synchroniser pour le moment',
            localIconInfoPrefix: "L'icône",
            localIconInfoSuffix: ' indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.',
            retrieveAll: 'Tout récupérer',
            finishedSynchros: 'synchronisations terminées',
            syncAll: 'Tout synchroniser',
            remainsToSynchronize: 'Reste à synchroniser'
        },
        entityNames: {
            items: 'Items',
            auditRecords: 'Fiches de récolement',
            audits: 'Projets de récolement',
            thesaurusTerms: 'Termes de thésaurus',
            thesaurus: 'Thésaurus',
            entityFields: 'Données système',
            collaborators: 'Collaborateurs',
            authorities: 'Autorités',
            aliases: 'Alias',
            locations: 'Localisations'
        },
        search: {
            options: {
                sortType: {
                    auditType: 'Type de projet',
                    campaignCreationDate: 'Date de création de la campagne',
                    creationDate: 'Date de création',
                    identificationNumber: "Numéro d'identification",
                    identifier: 'Identifiant principal',
                    lastModification: 'Dernière modification',
                    mainTitle: 'Titre principal',
                    referenceNumber: 'Numéro de référence',
                }
            },
            queryPlaceholder: 'Mots clés ou N° de campagne',
            totalCount: '{totalResults}  Résultat(s) : 1 -',
            noResults: 'Aucun résultat',
            title: 'Objets de musée'
        },
        itemCreationImagePopup : {
            title: 'Ajouter une image',
            addImage: 'AJOUTER UNE IMAGE',
            ignore: 'PLUS TARD, IGNORER CETTE ETAPE'
        }
    },
    "fr-ca": {
        countryCode: "ca",
        auth: {
            login: {
                error: {
                    credentials: 'Vos identifiants sont incorrects',
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    password: {
                        error: "Veuillez saisir votre nom d'utilisateur",
                        label: 'Mot de passe'
                    },
                    submit: 'Se connecter',
                    submitting: 'Connexion...',
                    username: {
                        error: 'Veuillez saisir votre mot de passe',
                        label: "Nom d'utilisateur"
                    }
                }
            },
            renew: {
                slowNetwork: "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                spinner: 'Nous vous reconnectons...'
            }
        },
        actionBar: {
            newItems: 'Nouveaux objets',
            auditCampaign: 'Campagnes de récolement',
            synchro: 'Synchro'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Déployé le',
                checkForUpdate: {
                    help: "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    title: 'Vérifiez les mises à jour'
                },
                clearCache: {
                    help: "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    title: 'Vider le cache'
                },
                overrideLocale: {
                    help: 'La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.',
                    title: 'Forcer la langue anglaise'
                },
                resetLocaleOverride: {
                    help: 'La langue utilisé dépendra du paramètrage de votre terminal',
                    title: 'Réinitialiser la langue'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Etes-vous sûr de vouloir vous déconnecter ?'
        },
        offlineRibbon: {
            offline: 'Vous êtes hors connexion',
            online: 'Vous êtes connecté'
        },
        proxy: {
            error: {
                default: "Une erreur s'est produite sur la ressource {uri}",
                network: 'La communication avec le serveur a échoué',
                notFound: "La ressource {uri} n'a pas été trouvée",
                tokenHasExpired: 'Votre session a expiré'
            }
        },
        serviceWorker: {
            updateAvailable: "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        itemCard: {
            detailsNotAvailable: 'Détails non disponible',
            error: "L'objet ne peut pas être affiché",
            identifier: 'N° Inv. {identifier}',
            identifierError: "Erreur d'identification",
            location: 'Localisation',
            locationLabel: 'Destination: <strong>{title}</strong>',
            unknownLocation: 'Inconnue',
            title: 'Titre',
            locationSelector: { title: 'Choisissez une localisation', validate: 'Valider' }
        },
        entity: {
            addItem: {
                error: {
                    api: "L'objet n'a pas pu être ajouté",
                    network: 'La communication avec le serveur a échoué'
                },
                form: {
                    id: {
                        alreadyAdded: "L'objet est déjà existant dans le mouvement",
                        emptyError: "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        label: "Numéro d'inventaire",
                        notFoundError: "L'objet est inconnu"
                    },
                    location: {
                        emptyError: 'Sélectionnez une localisation',
                        label: 'Destination d’arrivée',
                        notFoundError: 'La localisation est inconnue'
                    },
                    submit: 'Ajouter',
                    submitting: 'Ajout...'
                },
                modal: { title: 'Ajouter un objet' }
            },
            closeMovement: {
                form: {
                    location: {
                        inputPlaceholder: 'Entrez une localisation...',
                        noResult: 'Aucun résultat'
                    }
                }
            }
        },
        firewall: {
            collabWarningMessage: "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            noGroupForUserWarningMessage: "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        maskFields: {
            boolean: { no: 'Non', undefined: 'Non défini', yes: 'Oui' },
            entitySelect: { modalPlaceholder: 'Mots clés ou identifiants...' }
        },
        editItemScreen: {
            author: 'Auteur',
            inventoryNumber: "N° d'inventaire",
            saveNotification: {
                errorMessage: "Une erreur est survenue pendant la sauvegarde de l'objet",
                successMessage: "L'objet a été sauvegardé avec succès"
            },
            deleteNotification: {
                errorMessage: "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
                successMessage: "L'objet a été supprimé avec succès"
            },
            deleteModificationsNotification: {
                errorMessage: "Une erreur est survenue pendant la suppression des modifications non synchronisées",
                successMessage: "Les modifications ont été annulées"
            },
            menu: {
                saveModifications: 'Sauvegarder les modifications',
                deleteNotSynchronizedNewItem: 'Supprimer le nouvel objet',
                deleteModificationsNotSynchronized: 'Supprimer les modifications non synchronisées',
                offlineWarning: "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                offlineShortWarning: 'Modifié sur cet appareil'
            }
        },
        editRecordScreen: {
            auditDate: 'Date de récolement',
            linkedObject: 'Objet lié',
            realTimeLocation: 'Localisation en temps réel',
            itemNotice: 'Fiche objet',
            recordStatus: 'Statut de la fiche',
            medias: { accordionPanelTitle: 'MÉDIAS' },
            menu: {
                saveModifications: 'Sauvegarder les modifications',
                changeRecordStatus: 'Modifier le statut de la fiche',
                statusModificationWarning: 'Confirmer la modification ?',
                offlineWarning: "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                offlineShortWarning: 'Modifié sur cet appareil'
            },
            notifications: {
                saveError: 'Une erreur est survenue lors de la sauvegarde',
                saveSuccess: 'Fiche de récolement sauvegardée',
                stateTransitionError: 'Une erreur est survenue pendant la modification du statu de la fiche',
                stateTransitionSuccess: 'Statut de la fiche modifié avec succès',
                addToCampaign: 'Récoler cet objet'
            }
        },
        defectTree: {
            annotation: {
                deleteConfirmationMessage: 'Confirmer la suppression ?',
                defaultImageConfirmationMessage : 'Définir comme image par défaut ?'
            }
        },
        itemSearchScreen: {
            camera: 'APPAREIL PHOTO',
            modifyRecord: 'MODIFIER LA FICHE OBJET',
            createNewItem: 'CRÉER UN NOUVEL OBJET'
        },
        searchFeaturedCard: {
            institutionLabel: 'Institution'
        },
        auditCampaignSearchScreen: {
            inProgress: 'En cours',
            title: 'Projets de pointage/récolement en cours',
            noResultsPlaceholder: "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        recordSearchScreen: {
            auditors: 'Récoleurs',
            campaignManager: 'Responsable de la campagne',
            inventoryNumber: "N° d'inventaire",
            projectCreationDate: 'Date de création du projet',
            projectType: 'Type de projet',
            realTimeLocation: 'Localisation en temps réel',
            recordRefNumber: 'Référence fiche',
            status: 'Statut',
            title: 'Fiches de récolement',
            unknowLocation: 'Localisation Inconnue',
            menu: { addItem: 'Ajouter un objet' }
        },
        state: {
            all: 'Tous',
            archived: 'Archivé',
            canceled: 'Annulé',
            finalized: 'Terminé',
            inPreparation: 'En préparation',
            inProgress: 'En cours',
            programmed: 'Planifié',
            toValidated: 'À valider',
            validated: 'Validé',
            aborted: 'Interrompue',
            success: 'Terminée avec succès',
            error: 'Erreur',
            none: 'Aucune synchronisation précédente'
        },
        time: { hours: 'heure(s)', minutes: 'minute(s)', seconds: 'seconde(s)' },
        locationSelector: {
            inputPlaceholder: 'Entrez une localisation',
            title: 'Choisissez une localisation',
            validate: 'Valider'
        },
        synchroModal: {
            lastFetch: 'Dernière récupération',
            duration: 'Durée',
            status: 'Statut',
            details: 'Détails',
            lastSynchro: 'Dernière synchronisation',
            noEntityToSync: 'Aucune entité à synchroniser',
            connectionWarningPrefix: 'Vous devez être connecté à internet pour pouvoir',
            connectWarningSend: 'envoyer',
            connectWarningRetrieve: 'récupérer',
            connectionWarningSuffix: 'des données',
            noDataToSync: 'Aucune donnée à synchroniser pour le moment',
            localIconInfoPrefix: "L'icône",
            localIconInfoSuffix: ' indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.',
            retrieveAll: 'Tout récupérer',
            finishedSynchros: 'synchronisations terminées',
            syncAll: 'Tout synchroniser',
            remainsToSynchronize: 'Reste à synchroniser'
        },
        entityNames: {
            items: 'Items',
            auditRecords: 'Fiches de récolement',
            audits: 'Projets de récolement',
            thesaurusTerms: 'Termes de thésaurus',
            thesaurus: 'Thésaurus',
            entityFields: 'Données système',
            collaborators: 'Collaborateurs',
            authorities: 'Autorités',
            aliases: 'Alias',
            locations: 'Localisations'
        },
        search: {
            options: {
                sortType: {
                    auditType: 'Type de projet',
                    campaignCreationDate: 'Date de création de la campagne',
                    identificationNumber: "Numéro d'identification"
                }
            },
            queryPlaceholder: 'Mots clés ou N° de campagne',
            totalCount: '{totalResults}  Résultat(s) : 1 -'
        },
        itemCreationImagePopup : {
            title: 'Ajouter une image',
            addImage: 'AJOUTER UNE IMAGE',
            ignore: 'PLUS TARD, IGNORER CETTE ETAPE'
        }
    },
    nl: {
        auth: {
            login: {
                error: {
                    credentials: 'Gebruikersnaam en/of paswoord niet correct',
                    network: 'Communicatie met server mislukt'
                },
                form: {
                    password: {
                        error: 'Gelieve uw gebruikersnaam in te voeren',
                        label: 'Paswoord'
                    },
                    submit: 'Inloggen',
                    submitting: 'Aan het inloggen…',
                    username: {
                        error: 'Gelieve uw paswoord in te voeren',
                        label: 'Gebruikersnaam'
                    }
                }
            },
            renew: {
                slowNetwork: 'Dit duurt langer dan gebruikelijk. Gelieve de toepassing niet te sluiten.',
                spinner: 'We brengen u terug online '
            }
        },
        actionBar: {
            newItems: 'TRANSLATION IN PROGRESS',
            auditCampaign: 'TRANSLATION IN PROGRESS',
            synchro: 'TRANSLATION IN PROGRESS'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Ingezet/Ontwikkeld op:',
                checkForUpdate: {
                    help: 'Als een update beschikbaar is, zal die automatisch worden geïnstalleerd.',
                    title: 'Gelieve te controleren op updates'
                },
                clearCache: {
                    help: 'Als u offline bent, heeft u niet langer toegang tot alle gegevens die op uw toestel zijn opgeslagen.',
                    title: 'Maak cache (tijdelijk geheugen) leeg'
                },
                overrideLocale: {
                    help: 'Het Engels zal worden gebruikt en de instellingen van uw apparaat zullen worden genegeerd.',
                    title: 'Het Engels forceren'
                },
                resetLocaleOverride: {
                    help: 'De gebruikte taal zal afhangen van de instellingen van uw terminal',
                    title: 'Stel taal opnieuw in'
                },
                title: 'Skin-REPORTER'
            },
            logout: 'Bent u zeker dat u wil uitloggen?'
        },
        offlineRibbon: { offline: 'U bent nu offline', online: 'TRANSLATION IN PROGRESS' },
        proxy: {
            error: {
                default: 'Error bij de hulpbron {uri}',
                network: 'Communicatie met server mislukt',
                notFound: 'De oplossing {uri} kon niet worden gevonden',
                tokenHasExpired: 'Uw sessie is vervallen'
            }
        },
        serviceWorker: {
            updateAvailable: 'Update werd geïnstalleerd. U kunt ofwel hier klikken om de pagina te vernieuwen ofwel de toepassing opnieuw opstarten'
        },
        itemCard: {
            detailsNotAvailable: 'MISSING TRANSLATION',
            error: 'MISSING TRANSLATION',
            identifier: 'MISSING TRANSLATION',
            identifierError: 'MISSING TRANSLATION',
            location: 'MISSING TRANSLATION',
            locationLabel: 'MISSING TRANSLATION',
            unknownLocation: 'MISSING TRANSLATION',
            title: 'MISSING TRANSLATION',
            locationSelector: { title: 'MISSING TRANSLATION', validate: 'MISSING TRANSLATION' }
        },
        entity: {
            addItem: {
                error: { api: 'MISSING TRANSLATION', network: 'MISSING TRANSLATION' },
                form: {
                    id: {
                        alreadyAdded: 'MISSING TRANSLATION',
                        emptyError: 'MISSING TRANSLATION',
                        label: 'MISSING TRANSLATION',
                        notFoundError: 'MISSING TRANSLATION'
                    },
                    location: {
                        emptyError: 'MISSING TRANSLATION',
                        label: 'MISSING TRANSLATION',
                        notFoundError: 'MISSING TRANSLATION'
                    },
                    submit: 'MISSING TRANSLATION',
                    submitting: 'MISSING TRANSLATION'
                },
                modal: { title: 'MISSING TRANSLATION' }
            },
            closeMovement: {
                form: {
                    location: {
                        inputPlaceholder: 'MISSING TRANSLATION',
                        noResult: 'MISSING TRANSLATION'
                    }
                }
            }
        },
        firewall: {
            collabWarningMessage: 'MISSING TRANSLATION',
            noGroupForUserWarningMessage: 'MISSING TRANSLATION'
        },
        maskFields: {
            boolean: {
                no: 'MISSING TRANSLATION',
                undefined: 'MISSING TRANSLATION',
                yes: 'MISSING TRANSLATION'
            },
            entitySelect: { modalPlaceholder: 'MISSING TRANSLATION' }
        },
        editItemScreen: {
            author: 'MISSING TRANSLATION',
            inventoryNumber: 'MISSING TRANSLATION',
            saveNotification: {
                errorMessage: 'MISSING TRANSLATION',
                successMessage: 'MISSING TRANSLATION'
            },
            deleteNotification: {
                errorMessage: 'TRANSLATING IN PROGRESS',
                successMessage: 'TRANSLATING IN PROGRESS'
            },
            deleteModificationsNotification: {
                errorMessage: 'TRANSLATING IN PROGRESS',
                successMessage: 'TRANSLATING IN PROGRESS'
            },
            menu: {
                saveModifications: 'Save modifications',
                deleteNotSynchronizedNewItem: 'TRANSLATING IN PROGRESS',
                deleteModificationsNotSynchronized: 'TRANSLATING IN PROGRESS',
                offlineWarning: 'Modifications are saved on this device, you will have to synchronize them with the database when the network is back.',
                offlineShortWarning: 'Modified on this device',
                addToCampaign: 'MISSING TRANSLATION'
            }
        },
        editRecordScreen: {
            auditDate: 'MISSING TRANSLATION',
            linkedObject: 'MISSING TRANSLATION',
            realTimeLocation: 'MISSING TRANSLATION',
            itemNotice: 'MISSING TRANSLATION',
            recordStatus: 'MISSING TRANSLATION',
            medias: { accordionPanelTitle: 'BIJGEVOEGDE MULTIMEDIA' },
            menu: {
                saveModifications: 'MISSING TRANSLATION',
                changeRecordStatus: 'MISSING TRANSLATION',
                statusModificationWarning: 'MISSING TRANSLATION',
                offlineWarning: 'MISSING TRANSLATION',
                offlineShortWarning: 'MISSING TRANSLATION'
            },
            notifications: {
                saveError: 'MISSING TRANSLATION',
                saveSuccess: 'MISSING TRANSLATION',
                stateTransitionError: 'MISSING TRANSLATION',
                stateTransitionSuccess: 'MISSING TRANSLATION'
            }
        },
        defectTree: {
            annotation: {
                deleteConfirmationMessage: 'Bevestig schrapping?',
                defaultImageConfirmationMessage : 'MISSING TRANSLATION'
            }
        },
        itemSearchScreen: {
            camera: 'MISSING TRANSLATION',
            modifyRecord: 'MISSING TRANSLATION',
            createNewItem: 'MISSING TRANSLATION'
        },
        searchFeaturedCard: {
            institutionLabel: 'Instelling'
        },
        auditCampaignSearchScreen: {
            inProgress: 'MISSING TRANSLATION',
            title: 'MISSING TRANSLATION',
            noResultsPlaceholder: 'MISSING TRANSLATION'
        },
        recordSearchScreen: {
            auditors: 'MISSING TRANSLATION',
            campaignManager: 'MISSING TRANSLATION',
            inventoryNumber: 'MISSING TRANSLATION',
            projectCreationDate: 'MISSING TRANSLATION',
            projectType: 'MISSING TRANSLATION',
            realTimeLocation: 'MISSING TRANSLATION',
            recordRefNumber: 'MISSING TRANSLATION',
            status: 'MISSING TRANSLATION',
            title: 'MISSING TRANSLATION',
            unknowLocation: 'MISSING TRANSLATION',
            menu: { addItem: 'MISSING TRANSLATION' }
        },
        state: {
            all: 'MISSING TRANSLATION',
            archived: 'MISSING TRANSLATION',
            canceled: 'MISSING TRANSLATION',
            finalized: 'MISSING TRANSLATION',
            inPreparation: 'MISSING TRANSLATION',
            inProgress: 'MISSING TRANSLATION',
            programmed: 'MISSING TRANSLATION',
            toValidated: 'MISSING TRANSLATION',
            validated: 'MISSING TRANSLATION',
            aborted: 'MISSING TRANSLATION',
            success: 'MISSING TRANSLATION',
            error: 'MISSING TRANSLATION',
            none: 'MISSING TRANSLATION'
        },
        time: {
            hours: 'MISSING TRANSLATION',
            minutes: 'MISSING TRANSLATION',
            seconds: 'MISSING TRANSLATION'
        },
        locationSelector: {
            inputPlaceholder: 'MISSING TRANSLATION',
            title: 'MISSING TRANSLATION',
            validate: 'MISSING TRANSLATION'
        },
        synchroModal: {
            lastFetch: 'MISSING TRANSLATION',
            duration: 'MISSING TRANSLATION',
            status: 'MISSING TRANSLATION',
            details: 'MISSING TRANSLATION',
            lastSynchro: 'MISSING TRANSLATION',
            noEntityToSync: 'MISSING TRANSLATION',
            connectionWarningPrefix: 'MISSING TRANSLATION',
            connectWarningSend: 'MISSING TRANSLATION',
            connectWarningRetrieve: 'MISSING TRANSLATION',
            connectionWarningSuffix: 'MISSING TRANSLATION',
            noDataToSync: 'MISSING TRANSLATION',
            localIconInfoPrefix: 'MISSING TRANSLATION',
            localIconInfoSuffix: 'MISSING TRANSLATION',
            retrieveAll: 'MISSING TRANSLATION',
            finishedSynchros: 'MISSING TRANSLATION',
            syncAll: 'MISSING TRANSLATION',
            remainsToSynchronize: 'MISSING TRANSLATION'
        },
        entityNames: {
            items: 'MISSING TRANSLATION',
            auditRecords: 'MISSING TRANSLATION',
            audits: 'MISSING TRANSLATION',
            thesaurusTerms: 'MISSING TRANSLATION',
            thesaurus: 'MISSING TRANSLATION',
            entityFields: 'MISSING TRANSLATION',
            collaborators: 'MISSING TRANSLATION',
            authorities: 'MISSING TRANSLATION',
            aliases: 'MISSING TRANSLATION',
            locations: 'MISSING TRANSLATION'
        },
        search: {
            options: {
                sortType: {
                    auditType: 'MISSING TRANSLATION',
                    campaignCreationDate: 'MISSING TRANSLATION',
                    identificationNumber: 'MISSING TRANSLATION',
                    creationDate: 'MISSING TRANSLATION',
                    identifier: 'MISSING TRANSLATION',
                    lastModification: 'MISSING TRANSLATION',
                    mainTitle: 'MISSING TRANSLATION',
                    referenceNumber: 'MISSING TRANSLATION'
                }
            },
            queryPlaceholder: 'MISSING TRANSLATION',
            totalCount: 'MISSING TRANSLATION'
        },
        itemCreationImagePopup : {
            title: 'MISSING TRANSLATION',
            addImage: 'MISSING TRANSLATION',
            ignore: 'MISSING TRANSLATION'
        }
    },
    es: {
        auth: {
            login: {
                error: {
                    credentials: 'Sus datos de acceso son incorrectos',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    password: {
                        error: 'Por favor, introduzca su nombre de usuario',
                        label: 'Contraseña'
                    },
                    submit: 'Entrar en el sistema',
                    submitting: 'Conectando...',
                    username: {
                        error: 'Por favor, introduzca su contraseña',
                        label: 'Nombre de usuario'
                    }
                }
            },
            renew: {
                slowNetwork: 'Si parece que tarda más de lo habitual, no abandones la aplicación.',
                spinner: 'Le reconectamos...'
            }
        },
        actionBar: {
            newItems: 'TRANSLATION IN PROGRESS',
            auditCampaign: 'TRANSLATION IN PROGRESS',
            synchro: 'TRANSLATION IN PROGRESS'
        },
        navbar: {
            contextMenuModal: {
                buildDate: 'Desplegado en',
                checkForUpdate: {
                    help: 'Si hay una actualización disponible, se instalará automáticamente.',
                    title: 'Comprobar las actualizaciones'
                },
                clearCache: {
                    help: 'Si está sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.',
                    title: 'Vaciar la caché'
                },
                overrideLocale: {
                    help: 'Se utilizará el idioma inglés y se ignorará la configuración de su terminal.',
                    title: 'Forzar el idioma inglés'
                },
                resetLocaleOverride: {
                    help: 'El idioma utilizado dependerá de la configuración de su terminal',
                    title: 'Restablecer el idioma'
                },
                title: 'Skin-REPORTER'
            },
            logout: '¿Está seguro de que quiere desconectarse?'
        },
        offlineRibbon: { offline: 'Usted está fuera de línea', online: 'Está conectado' },
        proxy: {
            error: {
                default: 'Se ha producido un error en el recurso {uri}',
                network: 'La comunicación con el servidor ha fallado',
                notFound: 'No se ha encontrado el recurso {uri}',
                tokenHasExpired: 'Su sesión ha expirado'
            }
        },
        serviceWorker: {
            updateAvailable: 'Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación'
        },
        itemCard: {
            detailsNotAvailable: 'Detalles no disponibles',
            error: 'El objeto no se puede mostrar',
            identifier: 'Nº de inventario {identifier}',
            identifierError: 'Identificación errónea',
            location: 'Ubicación',
            locationLabel: 'Destino: <strong>{title}</strong>',
            unknownLocation: 'Desconocido',
            title: 'Título',
            locationSelector: { title: 'Elije una ubicación', validate: 'Validar' }
        },
        entity: {
            addItem: {
                error: {
                    api: 'No se ha podido añadir el objeto',
                    network: 'La comunicación con el servidor ha fallado'
                },
                form: {
                    id: {
                        alreadyAdded: 'El objeto ya existe en el movimiento',
                        emptyError: 'Por favor, escanee un artículo o introduzca su número de inventario',
                        label: 'Número de inventario',
                        notFoundError: 'El objeto es desconocido'
                    },
                    location: {
                        emptyError: 'Seleccione una ubicación',
                        label: 'Destino de la llegada',
                        notFoundError: 'La ubicación es desconocida'
                    },
                    submit: 'Añadir',
                    submitting: 'Añadiendo...'
                },
                modal: { title: 'Añadir un objeto' }
            },
            closeMovement: {
                form: {
                    location: {
                        inputPlaceholder: 'Introduzca una ubicación...',
                        noResult: 'No hay resultados'
                    }
                }
            }
        },
        firewall: {
            collabWarningMessage: 'Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal',
            noGroupForUserWarningMessage: 'El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios'
        },
        maskFields: {
            boolean: { no: 'No', undefined: 'No definido', yes: 'Sí' },
            entitySelect: { modalPlaceholder: 'Palabras clave o identificadores...' }
        },
        editItemScreen: {
            author: 'Autor',
            inventoryNumber: 'Número de inventario',
            saveNotification: {
                errorMessage: 'Se ha producido un error al guardar el objeto',
                successMessage: 'El objeto se ha guardado con éxito'
            },
            deleteNotification: {
                errorMessage: 'Se ha producido un error al borrar el objeto no sincronizado',
                successMessage: 'El objeto se ha borrado con éxito'
            },
            deleteModificationsNotification: {
                errorMessage: 'Se ha producido un error al borrar los cambios no sincronizado',
                successMessage: 'Los cambios han sido cancelados'
            },
            menu: {
                saveModifications: 'Guardar los cambios',
                deleteNotSynchronizedNewItem: 'Eliminar el nuevo objeto',
                deleteModificationsNotSynchronized: 'Eliminar las modificaciones no sincronizadas',
                offlineWarning: 'Los cambios se guardan en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.',
                offlineShortWarning: 'Modificado en este dispositivo',
                addToCampaign: 'MISSING TRANSLATION'
            }
        },
        editRecordScreen: {
            auditDate: 'Fecha de reacondicionamiento',
            linkedObject: 'Objeto relacionado',
            realTimeLocation: 'Localización en tiempo real',
            itemNotice: 'Maestro de objetos',
            recordStatus: 'Estado del registro maestro',
            medias: { accordionPanelTitle: 'MEDIA' },
            menu: {
                saveModifications: 'Guardar los cambios',
                changeRecordStatus: 'Cambiar el estado del registro',
                statusModificationWarning: '¿Confirmar el cambio?',
                offlineWarning: 'Los cambios se guardan en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.',
                offlineShortWarning: 'Modificado en este dispositivo'
            },
            notifications: {
                saveError: 'Se ha producido un error al guardar',
                saveSuccess: 'Registro guardado de la condición',
                stateTransitionError: 'Se ha producido un error al cambiar el estado del registro',
                stateTransitionSuccess: 'Estado del registro modificado con éxito'
            }
        },
        defectTree: {
            annotation: {
                deleteConfirmationMessage: '¿Confirmar el borrado?',
                defaultImageConfirmationMessage : '¿Establecer como imagen principal?'
            }
        },
        itemSearchScreen: {
            camera: 'MISSING TRANSLATION',
            modifyRecord: 'MISSING TRANSLATION',
            createNewItem: 'MISSING TRANSLATION'
        },
        searchFeaturedCard: {
            institutionLabel: 'Institución'
        },
        auditCampaignSearchScreen: {
            inProgress: 'En proceso',
            title: 'Proyectos de calificación/recuperación en proceso',
            noResultsPlaceholder: 'No puede trabajar en ninguna campaña en este momento'
        },
        recordSearchScreen: {
            auditors: 'Cosechadoras',
            campaignManager: 'Director de campaña',
            inventoryNumber: 'Número de inventario',
            projectCreationDate: 'Fecha de creación del proyecto',
            projectType: 'Tipo de proyecto',
            realTimeLocation: 'Localización en tiempo real',
            recordRefNumber: 'Referencia del archivo',
            status: 'Estado',
            title: 'Hojas de recogida',
            unknowLocation: 'Ubicación desconocida',
            menu: { addItem: 'Añadir un objeto' }
        },
        state: {
            all: 'Todos',
            archived: 'Archivado',
            canceled: 'Cancelado',
            finalized: 'Completado',
            inPreparation: 'En preparación',
            inProgress: 'En proceso',
            programmed: 'Planificado',
            toValidated: 'Por validar',
            validated: 'Validado',
            aborted: 'Interrumpido',
            success: 'Completado con éxito',
            error: 'Error',
            none: 'No hay sincronización previa'
        },
        time: { hours: 'hora(s)', minutes: 'minuto(s)', seconds: 'segundo(s)' },
        locationSelector: {
            inputPlaceholder: 'Introduzca una ubicación',
            title: 'Elija una ubicación',
            validate: 'Validar'
        },
        synchroModal: {
            lastFetch: 'Última recuperación',
            duration: 'Duración',
            status: 'Estado',
            details: 'Detalles',
            lastSynchro: 'Última sincronización',
            noEntityToSync: 'No hay entidades que sincronizar',
            connectionWarningPrefix: 'Debe estar conectado al Internet para poder',
            connectWarningSend: 'enviar',
            connectWarningRetrieve: 'recuperar',
            connectionWarningSuffix: 'datos',
            noDataToSync: 'No hay datos que sincronizar por el momento',
            localIconInfoPrefix: 'El icono',
            localIconInfoSuffix: ' indica que los datos correspondientes han sido modificados localmente y tendrán que ser sincronizados con la base de datos remota.',
            retrieveAll: 'Recuperar todo',
            finishedSynchros: 'sincronizaciones completadas',
            syncAll: 'Sincronizar todo',
            remainsToSynchronize: 'Restos por sincronizar'
        },
        entityNames: {
            items: 'Artículos',
            auditRecords: 'Hojas de recogida',
            audits: 'Proyectos de reconstrucción',
            thesaurusTerms: 'Términos del tesauro',
            thesaurus: 'Tesauro',
            entityFields: 'Datos del sistema',
            collaborators: 'Personal',
            authorities: 'Autoridades',
            aliases: 'Alias',
            locations: 'Ubicaciones'
        },
        search: {
            options: {
                sortType: {
                    auditType: 'Tipo de proyecto',
                    campaignCreationDate: 'Fecha de creación de la campaña',
                    identificationNumber: 'Número de identificación',
                    creationDate: 'MISSING TRANSLATION',
                    identifier: 'MISSING TRANSLATION',
                    lastModification: 'MISSING TRANSLATION',
                    mainTitle: 'MISSING TRANSLATION',
                    referenceNumber: 'MISSING TRANSLATION'
                }
            },
            queryPlaceholder: 'Palabras clave o número de campaña',
            totalCount: '{totalResults} Resultado(s) : 1 -'
        },
        itemCreationImagePopup : {
            title: 'MISSING TRANSLATION',
            addImage: 'MISSING TRANSLATION',
            ignore: 'MISSING TRANSLATION'
        }
    }
}

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
};
